export default "__VITE_ASSET__3314ebda__"